<template>
  <v-app style="background-color:#eeeeee">
    

     <div style="padding-top:200px">
           <v-container>
               <v-card flat style="border:1px solid;border-color:#212121">
                   <v-layout row wrap>
                       <v-flex xs12 sm12 md4 style="text-align:center">
                           <h5 style="font-weight:bold">Enquiry ID :&nbsp;<span style="color:grey">{{form.code}}</span></h5>
                       </v-flex>
                       <v-flex xs12 sm12 md4 style="text-align:center">
                           <h5 style="font-weight:bold">Enquiry Date :&nbsp;<span style="color:grey">{{form.date}}</span></h5>
                       </v-flex>
                       <v-flex xs12 sm12 md4 style="text-align:center">
                           <h5 style="font-weight:bold">Quotation Submitted :&nbsp;<span style="color:grey">{{form.count}}</span></h5>
                       </v-flex>
                   </v-layout>
               </v-card>


               <v-card style="margin-top:10px;border:1px solid;border-color:#e53935">
                   <v-data-table :headers="headers" hide-actions :items="form.list" :loading="false">
      <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props">
        <tr>
          <td class="text-xs-left">
            <img height="70px" width="70px" style="padding:5px" :src=props.item.src />
            <h6>{{props.item.name}}</h6>
        </td>
        <td class="text-xs-left">{{props.item.quantity}}</td>
        <td class="text-xs-left">
            <v-text-field type="Number" color="black" v-model="props.item.rate"></v-text-field>
        </td>
        <td class="text-xs-left">{{(props.item.quantity * props.item.rate).toFixed(2)}}</td>
        </tr>
      </template>
    </v-data-table>
               </v-card>

               <v-card flat style="margin-top:10px;border:2px solid;border-color:white;background-color:#212121">
                   <v-layout row wrap>
                       <v-flex xs12 sm12 md4 style="text-align:center;color:white">
                           <h5 style="margin-top:10px">Total Amount :&nbsp;{{totalAmount.toFixed(2)}}</h5>
                       </v-flex>
                       <v-flex xs12 sm12 md4></v-flex>
                       <v-flex xs12 sm12 md4 style="text-align:center">
                           <v-btn dark :loading="btnSave" depressed color="#e53935" @click="onSubmit()">Submit Quotation</v-btn>
                       </v-flex>
                   </v-layout>
               </v-card>
           </v-container>
     </div>

  </v-app>
</template>

<script>
import config from "./../../config.json";
import carousel from 'vue-owl-carousel';
//import VueEasyLightbox from 'vue-easy-lightbox';
import GoTop from '@inotom/vue-go-top';

export default {
  components: {
    GoTop,
    carousel,
  },
  data() {
    return {
      valid: true,
      btnSave: false,
      roleType: sessionStorage.roles,
      loggedInUserID: sessionStorage.loggedInUserID,
      form: {
      },

      headers: [
        { text: "PRODUCT", value: "name" },
        { text: "QUANTITY", value: "qty" },
        { text: "RATE", value: "rate" },
        { text: "TOTAL", value: "total" },
      ],
    };
  },
  
   mounted() {
     this.getData();
   },

 methods: {
     getData() {
         this.axios
        .get(config.API + `OrderDetails/${this.$route.params.id}`, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.form = res.data;
          console.log(this.form);
          this.$Progress.finish();
        })
        .catch(err => {
          this.$Progress.fail();
        });
     },

     onSubmit() {
       if (sessionStorage.loggedInUserID != null) {
         if(this.roleType == 'Vendor') {
           /* console.log({
             totalAmount: JSON.parse(this.totalAmount),
              orderId: JSON.parse(this.$route.params.id),
              quotationDetails: this.form.list
           }); */
           this.btnSave = true;
        this.axios
          .post(
            config.API + `Quotations`,
            {
              totalAmount: JSON.parse(this.totalAmount),
              orderId: JSON.parse(this.$route.params.id),
              quotationDetails: this.form.list
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Successfully send");
            this.$router.push("/myQuotation");
          })
          .catch(err => {
            this.$toaster.error("A quotation has been already submitted by you regarding this enquiry");
            this.btnSave = false;
          });
         }
         else {
           this.$toaster.error("Only vendor can send a quotation");
         }
      }
      else {
        this.$router.push("/login");
      }
     }
 },

 computed: {
     totalAmount: function() {
      let total = [];
      Object.entries(this.form.list).forEach(([key, val]) => {
        total.push(val.quantity * val.rate); // the value of the current key.
      });
      return total.reduce(function(total, num) {
        return total + num;
      }, 0);
    }
 }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nanum+Gothic&display=swap');
@import url('https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap');
@import url('https://fonts.googleapis.com/css?family=Anton&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lexend+Tera&family=Open+Sans:wght@600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Metal+Mania&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Patua+One&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Galada&family=Modak&family=Roboto&family=Roboto+Mono:ital,wght@1,600&display=swap');
</style>

<style scoped>
.banner {
  background-image: url('https://cdnimg.webstaurantstore.com/uploads/seo_category/2018/10/commercial-refrigeration_1.jpg');
  background-size: cover;

  height:300px;
}
.hvr:hover {
  cursor: pointer;
  /* height: 200px; */
  border : 2px solid;
  border-color: black !important;
}
.hvr1:hover {
  cursor: pointer;
  text-decoration: underline;
  color: #2196f3;
}
.v-card {
  padding: 10px;
  border-radius: 8px;
}
.v-sheet--offsets {
  top: -50px;
  position: relative;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.v-sheet--offsetf {
  top: -100px;
  position: relative;
}
.swo {
  box-shadow: none !important;
}
.opa {
  opacity: 1;
}
.tourtheme {
  height: 180px;
  margin: 5px;
  background-size: cover;
}
.themecap {
  font-family: 'Open Sans', sans-serif;
  padding-top: 130px;
  color: white;
}
.top-left {
  font-family: 'Roboto Mono', monospace;
  font-size:40px ;
  padding-top: 200px;
  color: white;
  text-align: center;
}
.salont {
  font-family: 'Patua One', cursive;
}
.hvr:hover {
  cursor: pointer;
  /* height: 200px; */
  border : 3px solid;
  border-color: white;
}
.v-table tbody tr:not(:last-child) {
    border-bottom: none !important;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
img.center {
    display: block;
    margin: 0 auto;
}
.recent {
  font-family: 'Nanum Gothic', sans-serif;
}
.srch {
  position: absolute;
  z-index: 10;
  left: 16%;
  top: 0%;
}
.item {
    border:1px solid !important;
}
</style>
